<template>
	<div class="parent">
		<comments
		:joborderid="comment_joborderid"
		:show="show_comments"
		v-on:cancel="cancel_comment"
		v-on:save="save_comment"
		></comments>

		<schedule-dialog
		:joborderid="schedule_joborderid"
		:show="show_schedule_dialog"
		v-on:cancel="cancel_schedule_dialog"
		v-on:save="save_schedule_dialog"
		></schedule-dialog>

		<div style="display:inline-block">
	        <div class="search-field" style="float:left; display: flex; height: 30px; margin-bottom:0px;">
	            <button v-on:click="clear()" style="height:30px; width:40px;"><font-awesome-icon icon="times" /></button>
	    		<input v-model="search_term" @keydown.enter="search()" style="height:30px; margin:1px;"></input>
	            <button v-on:click="search()" style="height:30px; width:40px;"><font-awesome-icon icon="search" /></button>
				<p class="saving" v-if="saved">Saved</p>
				<p class="saving" v-else>Saving...</p>
	        </div>
		</div>

		<div class="scroll" style="margin-bottom:10px" id="scheduleTable">
			<table :key=update_key>
				<thead v-if="column_names.length>0">
					<tr>
						<th
						v-bind:colspan="column_names.length+1"
						class="table-header">
							Scheduling Table <button class="copy-table" style="float:none" v-on:click="scroll_to_current_day()">Current Day</button> <button class="copy-table" v-on:click="copyTable()">Copy Table</button>
						</th>
					</tr>

					<tr>
						<th style="width:30px">Select</th>
						<th v-for="(name, index) in column_names">
							<div v-if="column_names[index] == 'Add_Comment'" style="display:inline-block; white-space:nowrap;">
								Add Comment
							</div>
							<div v-else style="display:inline-block; white-space:nowrap;">
								{{name}}
							</div>
						</th>
					</tr>
				</thead>
				<thead v-else-if="loading==true"><tr><th class="table-header">{{table_name}} Table Loading...</th></tr></thead>
				<thead v-else><tr><th class="table-header">{{table_name}} Table Empty</th></tr></thead>
				<tbody v-if="column_names.length>0">
					<tr v-for="(column, col) in column_data" v-bind:id="'tableRow-'+col">
						<td style="width:30px">
							<button v-on:click="edit_schedule(col)">Edit</button>
						</td>

						<td v-for="(data, index) in column" :class="{comments : column_names[index] == 'Comments'}">
							<div v-if="column_names[index] == 'Add_Comment'">
								<button v-on:click="add_comment(col)" style="width:130px;">Add Comment</button>
							</div>
							<div v-else-if="column_names[index] == 'Comments'" style="font-size:14px; overflow-y:scroll; max-height:60px; word-break:break-word;">
								{{data}}
							</div>
							<div v-else-if="column_names[index] == 'Side' && data!='null'" v-bind:id="'side-'+col">
								{{data}}
							</div>
							<div v-else-if="column_names[index] == 'Employee'">
								<autocomplete
								v-model=column_data[col][index]
								:type="16"
								:index="col"
								:do_first_send="false"
								v-on:full="set_employee"
								style="width:100%"/>
							</div>
							<div v-else>
								{{data}}
							</div>
						</td>
					</tr>
				</tbody>
			</table>
		</div>
	</div>
</template>

<script>
import {PAGES} from './../../../constants.js'
import api from '@/api'
import router from '@/router/index'
import { nextTick } from 'vue';
export default {
    props: {
		term: ''
    },
	data(){
		return{
			pageid:PAGES.SCHEDULING_II_PAGE,
			pageid2:PAGES.SCHEDULING_EMPLOYEE_PAGE,
			search_term:'',
			loading:true,
			update_key:0,
            lastUpdate: 0,

			column_names: [],
			column_data:[],

			show_comments:false,
			comment_joborderid:0,
			comment_index:0,

			show_schedule_dialog:false,
			schedule_joborderid:0,
			schedule_index:0,

			saved:true,
		}
	},
	async created () {
		this.search();
	},
	methods:{
		async search (){
			var currentTerm = this.search_term;

			if(currentTerm!=this.search_term && this.search_term!=undefined){
				return;
			}else{
				this.loading=true;

				let timestamp = new Date().getTime()

				api.postData(
					{
						type:"search",
						data:{
							pageid:this.pageid,
							data:[
								this.search_term,
							],
						},
						timestamp:timestamp,
					}
				).then((res) => {
					if(res.data.timestamp > this.lastUpdate){
						this.update_key++;
						this.lastUpdate = res.data.timestamp

						if(res.data.data!=null && res.data.data.column_data!=null){
							this.column_names = res.data.data.column_names;
							this.column_data = res.data.data.column_data;
						}
					}
				}).finally((res)=>{
					this.loading=false;
					nextTick(() => {
						api.setWOColors();
						this.scroll_to_current_day();
		            });
				});
			}
		},
        async clear (){
            this.search_term = "";
            this.search();
        },
		async select (index) {
			router.push('/0301?q='+this.column_data[index][0]);
			router.go(0)
		},

		async set_employee(index, employee) {
			api.postData(
				{
					type:"insert",
					data:{
						pageid:this.pageid2,
						term:this.column_data[index][0],
						data:[employee],
					}
				}
			).then((res) => {

			})
		},

		async add_comment(index) {
			let jobordercol = 0;
			for(var i = 0;i<this.column_names.length;i++){
				if(this.column_names[i]=='WONumber'){
					jobordercol = i;
				}
			}

			this.comment_index = index;
			this.comment_joborderid = parseInt(this.column_data[index][jobordercol].substr(3,5));
			this.show_comments = true;
		},
		async cancel_comment() {
			this.comment_index = 0;
			this.comment_joborderid = 0;
			this.show_comments = false;
		},
		async save_comment(comment) {
			for(var i = 0;i<this.column_names.length;i++){
				if(this.column_names[i]=='Comments'){
					this.column_data[this.comment_index][i] += ", "+comment;
				}
			}
		},

		async edit_schedule(index) {
			let jobordercol = 0;
			for(var i = 0;i<this.column_names.length;i++){
				if(this.column_names[i]=='WONumber'){
					jobordercol = i;
				}
			}

			this.schedule_index = index;
			this.schedule_joborderid = parseInt(this.column_data[index][jobordercol].substr(3,5));
			this.show_schedule_dialog = true;
		},
		async cancel_schedule_dialog() {
			this.schedule_index = 0;
			this.schedule_joborderid = 0;
			this.show_schedule_dialog = false;
		},
		async save_schedule_dialog() {

		},

		async copyTable(){
			var copyText = ''

			for(let i = 0;i < this.column_names.length;i++){
				copyText += this.column_names[i] + '\t'
			}
			copyText+='\n'

			for(let i = 0;i < this.column_data.length;i++){
				for(let j = 0; j< this.column_data[i].length;j++){
					copyText += this.column_data[i][j] + '\t'
				}
				copyText+='\n'
			}

			var el = document.createElement('textarea');
			el.value = copyText;
			document.body.appendChild(el);
			el.select();
			el.setSelectionRange(0, 99999);
			document.execCommand('copy');
			document.body.removeChild(el);
			alert("copied to clipboard")
		},
		scroll_to_current_day() {
			var now = new Date();
			var datetimeColumn = this.column_names.indexOf("Date");

			var col = -1;
			for(let i = 0; i<this.column_data.length;i++) {
				var time = new Date(this.column_data[i][datetimeColumn]);
				if(time > now) {
					col = i;
					break;
				}
				//delete time;
			}
			if(col == -1) col = this.column_data.length-1;

			var row = document.getElementById('tableRow-'+col);
			row.scrollIntoView({ behavior: 'smooth', block: 'center' });
		},
	},

	//be able to change employee, date, and notes (new field) directly on page
	//on click, pop-up to change date, employee, port, side, customer, type, notes, comments, joborder comments
	//whole row one color and more compact

	//change notes comments to notes in add functions
	//write insert function to update schedule on dialog save
	//emit value on dialog save and overwrite column_data

	//directly on page editing

}
</script>

<style scoped>

.comments {
	width:20%;
}
.saving {
	font-size: 10px;
	color: gray;
	text-decoration: underline;
	align-self: flex-end;
	margin-left:5px;
	margin-bottom:0px;
}

</style>



// WEBPACK FOOTER //
// src/components/view/Scheduling_V2.vue